<template>
<div class="container-fluid">
    <!-- Change this to device.status.system.system.hostname when available  -->
    <!-- {{canedit}} {{this.$can('devices','edit')}} -->
    <div class="card animated fadeIn" v-if="device.config != null && device.status.dhcp_dns.hosts != null">
        <b-row no-gutters>
            <b-col no-gutters sm=12>
                <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
                    <b-button class="btn btn-primary btn-sm float-right" variant="danger" v-if="device.presence && this.$can('device','edit')" @click="sendCmd(device.id, 'resetNreboot')">Factory Reset</b-button>
                    &nbsp;&nbsp;
                    <b-button class="btn btn-primary btn-sm float-right" variant="warning" v-if="device.presence && this.$can('device','edit') " @click="sendCmd(device.id, 'reboot')">Reboot</b-button>
                </b-card>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <!-- <b-col no-gutters sm=4>
                <b-card no-body border-variant="light">
                    <div slot="header">
                        <strong>System:</strong>
                    </div>
                    <statusdisplay :kkey="'Serial #'" :vvalue="device.serial"></statusdisplay>
                    <statusdisplay :kkey="'MAC Address'" :vvalue="device.mac"></statusdisplay>
                    <statusdisplay :kkey="'Hostname'" :vvalue="device.config.system.system[0].hostname"></statusdisplay>
                    <statusdisplay :kkey="'Firmware Version:'" :vvalue="device.fw_version"></statusdisplay>
                    <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="device.presence" @click="sendCmd(device.id, 'reboot')">Reboot</b-button>
                </b-card>
            </b-col>
            <b-col no-gutters sm=8>
                <b-card no-body border-variant="light">
                    <plotconnectsform :serial="device.serial" :deviceID="this.device.id"></plotconnectsform>
                </b-card>
            </b-col> -->
            <b-col sm=12 no-gutters>
                <system :device=device></system>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col sm=12 no-gutters>
                <statusinterface :device=device @childgetData_event="childgetData"></statusinterface>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col sm=12 no-gutters class="mb-2">
                <statusDHCPHosts :device=device @childgetData_event="childgetData"></statusDHCPHosts>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col no-gutters sm=12>
                <statuswirelessinterface :device=device @childgetData_event="childgetData"></statuswirelessinterface>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col sm=12 no-gutters class="mb-2">
                <!-- <b-card no-body border-variant="light">
                    <div slot="header">
                        <strong>Wireless Associated Hosts</strong> updated {{relativeTime(device.status.wireless.hosts.ts)}}
                        <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'wifiClients')">
                            <i class="fa fa-refresh"></i>
                        </b-button>
                    </div> -->

                <statusWIFIHosts :device="device" @childgetData_event="childgetData"></statusWIFIHosts>

                <!-- </b-card> -->
            </b-col>
        </b-row>
    </div>
    <div v-else>
        Upgrade firmware to view Status
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)

import moment from 'moment'
import StatusInterfaces from '@/readynet/devices/status/StatusInterfaces';
import StatusWirelessInterfaces from '@/readynet/devices/status/StatusWirelessInterfaces';
import StatusDisplay from '@/readynet/devices/status/StatusDisplay';
import StatusDHCPHosts from '@/readynet/devices/status/StatusDHCPHosts';
import StatusWIFIHosts from '@/readynet/devices/status/StatusWIFIHosts';
import PlotConnectsForm from '@/readynet/devices/graphs/PlotConnectsForm'
import System from '@/readynet/devices/status/System';

export default {
    components: {
        'system': System,
        'statusinterface': StatusInterfaces,
        'statuswirelessinterface': StatusWirelessInterfaces,
        'statusdisplay': StatusDisplay,
        'statusDHCPHosts': StatusDHCPHosts,
        'statusWIFIHosts': StatusWIFIHosts,
        'plotconnectsform': PlotConnectsForm,

    },
    props: {
        device: {
            type: Object,
        },
        changed: {
            type: Array,
            // default: () =>([]),
        }
    },
    data() {
        return {
            timer: false,
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },

    methods: {
        childgetData() {
            this.$emit('getData_event');
        },
        enableTimer() {
            this.timer = true;
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op) {
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {

                if (response.data.success === true) {
                    this.makeToast('info', 'Router updated.');
                    setTimeout(() => { console.log("World!"); }, 3000);
                    window.location.reload();
                    // this.$forceUpdate();
                } else {
                    this.makeToast('danger', 'Unable to update device.');
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    computed: {
        canedit() {
            return this.$can('device','edit')
        }
    },
};
</script>
